<template>
  <div>
    <!-- Directive -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("DIRECTIVE") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-textarea
          :spellcheck="false"
          dense
          outlined
          rows="2"
          v-model="formGeneral.leadSentence"
          :error-messages="leadSentenceErrors"
          @input="$v.formGeneral.leadSentence.$touch()"
          @blur="$v.formGeneral.leadSentence.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Question -->
    <v-row class="mb-3">
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("QUESTION") }}
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-row no-gutters align="center">
          <v-col>
            <draggable :list="formGeneral.name" ghost-class="sortable__ghost">
              <v-row
                class="ma-0 d-flex justify-center"
                v-for="(rowName, idx) in formGeneral.name"
                :class="{ 'mt-4': idx > 0 }"
                :key="`row-name-${idx}`"
              >
                <v-btn
                  icon
                  small
                  outlined
                  v-if="formGeneral.name.length > 1"
                  class="mt-2 mr-2"
                >
                  <v-icon small class="page__grab-icon">
                    fas fa-arrows-alt
                  </v-icon>
                </v-btn>
                <!-- <v-btn
                  icon
                  small
                  outlined
                  v-if="formGeneral.name.length > 1"
                  color="error"
                  class="mt-2 mr-2"
                  @click="handleDeleteName(formGeneral.name, idx)"
                >
                  <v-icon dark>fas fa-minus</v-icon>
                </v-btn> -->
                <v-col class="d-inline-flex pa-0">
                  <v-textarea
                    :spellcheck="false"
                    dense
                    :auto-grow="true"
                    outlined
                    rows="1"
                    hide-details
                    v-model="rowName[0]"
                  />
                </v-col>
                <template v-if="rowName[1] || rowName[1] == ''">
                  <v-col
                    class="d-inline-flex pa-0 row-name-center"
                    style="max-width: 235px; min-width: 235px"
                  >
                    <v-row class="d-flex mx-5 mt-1">
                      <v-btn class="mx-2" fab dark x-small color="#e47690">
                        <strong style="font-size: 24px">1</strong>
                      </v-btn>
                      <v-btn class="mx-2" fab dark x-small color="#96b74b">
                        <strong style="font-size: 24px">2</strong>
                      </v-btn>
                      <v-btn class="mx-2" fab dark x-small color="#5fa89f">
                        <strong style="font-size: 24px">3</strong>
                      </v-btn>
                      <v-btn class="mx-2" fab dark x-small color="#b37bde">
                        <strong style="font-size: 24px">4</strong>
                      </v-btn>
                    </v-row>
                    <!-- <v-icon
                      size="20px"
                      dark
                      color="error"
                      v-if="formGeneral.name.length > 1"
                      class="icon-times-circle"
                      @click="handleDeleteName(rowName, 1)"
                      >fas fa-times-circle</v-icon
                    > -->
                  </v-col>
                  <v-col class="d-inline-flex pa-0">
                    <v-textarea
                      :spellcheck="false"
                      dense
                      :auto-grow="true"
                      hide-details
                      outlined
                      rows="1"
                      v-model="rowName[1]"
                    />
                  </v-col>
                </template>
              </v-row>
            </draggable>
          </v-col>
          <v-btn
            class="ml-4 mt-1"
            icon
            small
            outlined
            color="success"
            @click="handleAddLineName"
          >
            <v-icon dark>fas fa-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <!-- Answer -->
    <v-row>
      <v-col cols="4" class="col-lable"></v-col>
      <v-col class="pa-0">
        <v-row>
          <v-col
            class="pl-2 py-0"
            cols="6"
            v-for="item in $v.formGeneral.answers.$each.$iter"
            :key="item.id"
          >
            <v-text-field
              class="ml-1"
              v-model="item.value.$model"
              :error-messages="answersErrors(item.value)"
              @input="item.value.$touch()"
              @blur="item.value.$touch()"
              dense
              outlined
            >
              <template v-slot:label>
                <h3>
                  {{ item.$model.name }}
                  <span class="red--text">*</span>
                </h3>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "FormSort",
  props: ["parent"],
  components: {
    draggable,
  },
  mixins: [validationMixin],
  store: ["formGeneral"],
  data() {
    return {
      format: /[^\u00BF-\u1FFF\u2C00-\uD7FF０-９Ａ-Ｚａ-ｚ_＿/／\s\w]/g,
    };
  },
  validations() {
    return {
      formGeneral: {
        answers: {
          required,
          $each: {
            value: {
              required,
              strongAnswers(answers) {
                return !this.format.test(answers); // checks for special char
              },
            },
          },
        },
        leadSentence: { required },
      },
    };
  },
  mounted() {
    let update = this.$route.name.search("Update");
    if (update == -1) {
      this.formGeneral.leadSentence = "正しい順番にならびかえてください。";
    }
  },
  computed: {
    leadSentenceErrors() {
      const errors = [];
      if (!this.$v.formGeneral.leadSentence.$dirty) return errors;
      !this.$v.formGeneral.leadSentence.required &&
        errors.push("指示文を入力してください。");
      return errors;
    },
    checkValidateName() {
      const { _ } = this;
      let check = _.filter(this.formGeneral.name, function (o) {
        return o.length > 1;
      });
      if (check.length > 1) return false;
      return true;
    },
  },
  methods: {
    async getParams() {
      this.$v.$touch();
      var params = "";
      if (!this.$v.$anyError) {
        const { leadSentence, name, isAnsewr, answers } = this.formGeneral;
        params = {
          sub_key: this.$route.params[this.parent],
          parent: this.parent,
          name: name,
          answer1: answers[0].value,
          answer2: answers[1].value,
          answer3: answers[2].value,
          answer4: answers[3].value,
          lead_sentence: leadSentence,
          audio: "",
          image: "",
          script: "",
          verb: "",
          answer_correct: [isAnsewr],
          sub_question: {
            question1: {
              answers: [
                {
                  id: 1,
                  name: "回答1",
                  value: "",
                },
                {
                  id: 2,
                  name: "回答2",
                  value: "",
                },
                {
                  id: 3,
                  name: "回答3",
                  value: "",
                },
                {
                  id: 4,
                  name: "回答4",
                  value: "",
                },
              ],
              audio: null,
              isAnsewr: 1,
              script: "",
            },
            question2: {
              answers: [
                {
                  id: 1,
                  name: "回答1",
                  value: "",
                },
                {
                  id: 2,
                  name: "回答2",
                  value: "",
                },
                {
                  id: 3,
                  name: "回答3",
                  value: "",
                },
                {
                  id: 4,
                  name: "回答4",
                  value: "",
                },
              ],
              audio: null,
              isAnsewr: 1,
              script: "",
            },
          },
          list_answer: {
            sentence_answer: [],
            answer: [],
          },
        };
      }
      return params;
    },
    answersErrors(value) {
      if (value.$dirty && !value.required) return "回答を入力してください。";
      if (value.$dirty && !value.strongAnswers) {
        console.log("value.strongAnswers: ", value.strongAnswers);
        return "特殊文字以外を入力してください。";
      }
    },
    handleDeleteName(rowName, idx) {
      this.$delete(rowName, idx);
      let check = this._.filter(this.formGeneral.name, function (o) {
        return o.length > 1;
      });
      if (check.length == 0) {
        let index = this._.findIndex(this.formGeneral.name, function (o) {
          return o === rowName;
        });
        if (this.formGeneral.name[index + 1]) {
          this.formGeneral.name[index + 1].push("");
        } else {
          this.formGeneral.name[index - 1].push("");
        }
      }
    },
    handleAddLineName() {
      if (this.checkValidateName) {
        this.formGeneral.name.push([""]);
      } else {
        this.formGeneral.name.push(["", ""]);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.row-name-center {
  position: relative;
  .icon-times-circle {
    position: absolute;
    right: 8px;
    top: 2px;
  }
}
.page__grab-icon {
  cursor: move;
}
.sortable__ghost {
  margin: 16px 0 !important;
}
</style>